"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Header = void 0;
const react_1 = __importDefault(require("react"));
require("./header.css");
const lang = __importStar(require("./lang.json"));
;
/**
 * Main component.
 * @name header
 * @param {HeaderProps<T>}
 * @returns {<Header />}
*/
const Header = ({ logoURL, logoClickHandler = () => { }, backgroundColor = "#ffffff" }) => {
    return (react_1.default.createElement("header", { "data-testid": "header-element", className: "header-container", style: { backgroundColor: backgroundColor } }, logoURL && (react_1.default.createElement("img", { "data-testid": "header-logo", className: "image-container", src: logoURL, alt: lang.imgAlt, onClick: (event) => logoClickHandler(event) }))));
};
exports.Header = Header;
//# sourceMappingURL=header.js.map